import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { Spin } from "common/elements";
import { Canvas } from "./Canvas";

export const MapMaker = () => {
  const loading = useSelector((state: RootState) => state.builder.loading);

  return (
    <div className="flex-col-center w-full h-full bg-[rgba(0,0,0,0.67)]">
      {loading && <Spin />}
      <Canvas />
    </div>
  );
};
